import { injectable } from 'inversify';
import {
  ModelRuleChangeProfil,
  ChangeProfilAction,
  ChangeProfilCarac,
} from '@Models';
import {
  model_rule_change_profil_full,
  profil_change_action,
  profil_change_carac,
} from '@Api';

@injectable()
export class ModelRuleChangeProfilMapper {
  public map(item: model_rule_change_profil_full): ModelRuleChangeProfil {
    return {
      action: this.mapAction(item.action),
      caracs: this.mapCarac(item.caracs),
      value: item.value,
    } satisfies ModelRuleChangeProfil as ModelRuleChangeProfil;
  }

  public mapAction(item: profil_change_action): ChangeProfilAction {
    switch (item) {
      case profil_change_action.ADD:
        return ChangeProfilAction.Add;
    }
    return ChangeProfilAction.Replace;
  }

  public mapCarac(item: profil_change_carac): ChangeProfilCarac {
    switch (item) {
      case profil_change_carac.CARAC_GROUND_MAR:
        return ChangeProfilCarac.ground_mar;
      case profil_change_carac.CARAC_FLY_ADV:
        return ChangeProfilCarac.fly_adv;
      case profil_change_carac.CARAC_FLY_MAR:
        return ChangeProfilCarac.fly_mar;
      case profil_change_carac.CARAC_DIS:
        return ChangeProfilCarac.dis;
      case profil_change_carac.CARAC_EVOKED:
        return ChangeProfilCarac.evoked;
      case profil_change_carac.CARAC_HP:
        return ChangeProfilCarac.hp;
      case profil_change_carac.CARAC_DEF:
        return ChangeProfilCarac.def;
      case profil_change_carac.CARAC_RES:
        return ChangeProfilCarac.res;
      case profil_change_carac.CARAC_ARM:
        return ChangeProfilCarac.arm;
      case profil_change_carac.CARAC_AEG:
        return ChangeProfilCarac.aeg;
      case profil_change_carac.CARAC_ATT:
        return ChangeProfilCarac.att;
      case profil_change_carac.CARAC_OF:
        return ChangeProfilCarac.of;
      case profil_change_carac.CARAC_STR:
        return ChangeProfilCarac.str;
      case profil_change_carac.CARAC_AP:
        return ChangeProfilCarac.ap;
      case profil_change_carac.CARAC_AGI:
        return ChangeProfilCarac.agi;
      case profil_change_carac.M:
        return ChangeProfilCarac.M;
      case profil_change_carac.WS:
        return ChangeProfilCarac.WS;
      case profil_change_carac.BS:
        return ChangeProfilCarac.BS;
      case profil_change_carac.S:
        return ChangeProfilCarac.S;
      case profil_change_carac.T:
        return ChangeProfilCarac.T;
      case profil_change_carac.W:
        return ChangeProfilCarac.W;
      case profil_change_carac.I:
        return ChangeProfilCarac.I;
      case profil_change_carac.A:
        return ChangeProfilCarac.A;
      case profil_change_carac.E:
        return ChangeProfilCarac.E;
      case profil_change_carac.LD:
        return ChangeProfilCarac.LD;
    }
    return ChangeProfilCarac.ground_adv;
  }
}
